module.exports = __webpack_public_path__ + "img/cutting-edge-en-5.40d6f32.jpg";